import { CheckCircleIcon as CheckCircleSolid } from '@heroicons/react/24/solid';
import React from 'react';

export const SoftSurveyComplete: React.FC<{
  language: 'en' | 'es';
  primaryColor: string;
  message: string;
  title?: string;
  onExit: () => void;
  exitLabel?: string;
}> = ({ language, primaryColor, message, title, onExit, exitLabel }) => (
  <div
    className="rounded-3xl overflow-hidden p-8 text-center flex flex-col items-center gap-3 dark:ring-1 dark:ring-white/10"
    style={{ backgroundColor: `${primaryColor}12` }}
  >
    <div
      className="size-12 rounded-full flex items-center justify-center"
      style={{ backgroundColor: `${primaryColor}25`, color: primaryColor }}
      aria-hidden="true"
    >
      <CheckCircleSolid className="size-7" />
    </div>
    <h1 className="text-xl sm:text-2xl font-bold tracking-tight text-gray-900 dark:text-gray-100">
      {title ?? (language === 'es' ? '¡Listo!' : 'All done')}
    </h1>
    <p className="max-w-prose text-sm text-gray-600 dark:text-gray-300">{message}</p>
    <button
      type="button"
      onClick={onExit}
      className="mt-2 inline-flex items-center justify-center rounded-full px-6 py-2.5 text-sm font-semibold text-white"
      style={{ backgroundColor: primaryColor }}
    >
      {exitLabel ?? (language === 'es' ? 'Volver al inicio' : 'Back to home')}
    </button>
  </div>
);
